/**
 * Runtime environment detection. Pure hostname-based, no build args.
 *
 * `isPreprodHost()` returns true when the user is on preprod OR a dev
 * environment (localhost). It returns false on prod (debono.ai) and on
 * tailnet IPs that hit the prod container (e.g. 100.111.71.48). Callers
 * use it to render dev/preprod-only surfaces — patterns:
 *
 *   {isPreprodHost() && <ExperimentalSurface />}
 *
 * Why hostname not REACT_APP_ENV: avoids new Dockerfile build args,
 * survives env-wiring drift, and the prod bundle on debono.ai vs the
 * preprod bundle on debono-preprod.phillyshell.cloud have different
 * Cloudflare hostnames anyway. Devs override via REACT_APP_ENV=preprod
 * only if they need preprod behavior on a non-localhost dev host.
 */
export function isPreprodHost() {
  // Explicit env override — useful for devs running against a custom
  // hostname who want preprod behavior.
  if (typeof process !== 'undefined' && process.env?.REACT_APP_ENV === 'preprod') {
    return true;
  }
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  if (host.includes('debono-preprod')) return true;
  if (host === 'localhost' || host === '127.0.0.1') return true;
  return false;
}

// Build-time kill switch for the new HTN authored drug-tooltip grammar. CRA
// bakes this value into each image: preprod opts in for feel-testing while the
// production image and local/default builds remain safe-off.
//
// NOTE: read `process.env.REACT_APP_*` DIRECTLY — no `typeof process` guard and
// no optional chaining. react-scripts' DefinePlugin replaces the bare
// `process.env` member expression with an inlined object literal at build time,
// so `process.env.REACT_APP_X` resolves in the browser. But bare `typeof process`
// is NOT shimmed by webpack 5, so `typeof process !== 'undefined'` is FALSE in the
// production browser bundle — which silently disabled this flag on the live app
// even though the value was baked in (jest has a real `process`, so unit tests
// still saw it as enabled). Match the App.jsx REACT_APP_ADMIN_HARNESS_ENABLED idiom.
export function isHtnDrugTooltipRowsEnabled() {
  return process.env.REACT_APP_HTN_DRUG_TOOLTIP_ROWS_ENABLED === 'true';
}
